import React from 'react'

import { type CarouselProps } from './Carousel'

type CarouselContextType = CarouselProps & {
  currentPage: number
  scrollOffset: number[]
  totalPages: number
  goToPage: (index: number) => void
  goForward: () => void
  goBack: () => void
}

export const CarouselContext = React.createContext<CarouselContextType>(
  {} as unknown as CarouselContextType,
)
export const CarouselProvider = CarouselContext.Provider
